import styled from 'styled-components'
import { CheckmarkIcon, colors } from '@chegg-ui/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const FeatureListItem = styled.li`
  position: relative;
  list-style: none;
  text-align: start;
  ${AspiraStack};
  font-size: ${({ theme }) => theme.font.text.size.md};
  font-weight: 500;
  line-height: 20px;
  margin-top: 16px;
  &:first-child {
    margin-top: 0px;
  }
`

export const SuccessIcon = styled(CheckmarkIcon).attrs({
  color: colors.cheggOrange,
})`
  position: absolute;
  margin: -11px -10px;
`

export const PaddingWrapper = styled.div`
  padding-left: 37px;
`

export const FeatureText = styled.span``
